import { connect } from "react-redux";
import PollsList from "../components/pollsList";
import { fetch, fetchResponse, pollArchive } from "../actions/pollActions";

const PollsListContainer = (props) => {
  return <PollsList {...props} />;
};

const mapStateToProps = (state) => {
  return {
    timers: state.timers.data,
    envContext: state.envContext?.data ?? {},
    user: state.auth?.data ?? {},
    isSubmitting: state.timers.isSubmitting,
    polls: state.polls,
    responseReport: state.responseReport,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetch: () => {
    dispatch(fetch());
  },
  archive: (data) => {
    dispatch(pollArchive(data));
  },
  fetchRepost: (slug) => {
    dispatch(fetchResponse(slug));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PollsListContainer);
